const FILTER_PARAM = 'works_cat';

/** WordPress 出力の絶対URL（:8001 等）を、今開いているオリジン（:3000 等）に合わせる */
function toCurrentOriginUrl(url) {
  const parsed = new URL(url, window.location.href);
  return `${window.location.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
}

function getWorksArchiveRoot() {
  return (
    document.querySelector('[data-works-archive-root]') ||
    document.querySelector('.p-works .works-archive-main')
  );
}

function getArchiveContent(root) {
  return root.querySelector('[data-works-archive-content]');
}

function setActiveButton(buttons, activeFilter) {
  buttons.forEach((btn) => {
    const isActive = btn.getAttribute('data-works-filter') === activeFilter;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
}

function getFilterFromUrl(url = window.location.href) {
  const slug = new URL(url, window.location.origin).searchParams.get(FILTER_PARAM);
  if (!slug) {
    return 'all';
  }
  return slug;
}

function getInitialFilter(root) {
  const fromUrl = getFilterFromUrl();
  if (fromUrl !== 'all') {
    const exists = root.querySelector(`[data-works-filter="${CSS.escape(fromUrl)}"]`);
    if (exists) {
      return fromUrl;
    }
  }
  return 'all';
}

function buildFilterUrl(root, filter) {
  const base = root.getAttribute('data-works-archive-url') || '/works/';
  const url = new URL(toCurrentOriginUrl(base));

  if (filter !== 'all') {
    url.searchParams.set(FILTER_PARAM, filter);
  }

  return url.href;
}

function scrollToUrlHash(url) {
  const hash = new URL(url, window.location.href).hash;
  if (!hash) {
    return;
  }

  const target = document.querySelector(hash);
  if (target) {
    target.scrollIntoView({ block: 'start' });
  }
}

function scrollToArchiveSection() {
  const target = document.getElementById('works01');
  if (target) {
    target.scrollIntoView({ block: 'start' });
  }
}

function resolveImageSrc(src) {
  if (!src) {
    return '';
  }
  return toCurrentOriginUrl(src);
}

/** fetch 差し替え前に画像を読み込み、DOM 挿入後も確実に表示する */
function preloadArchiveImages(panel) {
  const tasks = [...panel.querySelectorAll('img')].map((img) => {
    const resolvedSrc = resolveImageSrc(img.getAttribute('src'));
    if (!resolvedSrc) {
      return Promise.resolve();
    }

    img.removeAttribute('loading');
    img.removeAttribute('fetchpriority');
    img.setAttribute('src', resolvedSrc);

    if (img.complete && img.naturalWidth > 0) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const loader = new Image();
      loader.onload = () => {
        img.src = resolvedSrc;
        resolve();
      };
      loader.onerror = () => resolve();
      loader.src = resolvedSrc;
    });
  });

  return Promise.all(tasks);
}

async function loadWorksArchiveContent(url, root, options = {}) {
  const { updateHistory = true, scrollToHash = false, scrollToSection = false } = options;
  const requestUrl = toCurrentOriginUrl(url);
  const currentPanel = getArchiveContent(root);

  if (!currentPanel) {
    window.location.href = requestUrl;
    return;
  }

  root.classList.add('is-works-loading');
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;

  try {
    const response = await fetch(requestUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error(`Works archive fetch failed: ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextPanel = doc.querySelector('[data-works-archive-content]');

    if (!nextPanel) {
      throw new Error('Works archive content not found in response');
    }

    const importedPanel = document.importNode(nextPanel, true);
    await preloadArchiveImages(importedPanel);
    currentPanel.replaceWith(importedPanel);

    if (updateHistory) {
      const historyUrl = new URL(requestUrl);
      history.replaceState(
        null,
        '',
        `${historyUrl.pathname}${historyUrl.search}${historyUrl.hash}`
      );
    }

    if (scrollToHash) {
      scrollToUrlHash(requestUrl);
    } else if (scrollToSection) {
      scrollToArchiveSection();
    } else {
      window.scrollTo(scrollX, scrollY);
    }

    setActiveButton(root.querySelectorAll('[data-works-filter]'), getInitialFilter(root));
  } catch {
    window.location.href = requestUrl;
  } finally {
    root.classList.remove('is-works-loading');
  }
}

export function initWorksArchive() {
  const root = getWorksArchiveRoot();
  if (!root || root.dataset.worksArchiveBound === '1') {
    return;
  }

  root.dataset.worksArchiveBound = '1';

  const buttons = root.querySelectorAll('[data-works-filter]');
  setActiveButton(buttons, getInitialFilter(root));

  root.addEventListener(
    'click',
    (event) => {
    const pagerLink = event.target.closest('.worksPager-num[href]');
    if (pagerLink && root.contains(pagerLink)) {
      event.preventDefault();
      event.stopPropagation();
      loadWorksArchiveContent(pagerLink.href, root, { scrollToHash: true });
      return;
    }

    const filterBtn = event.target.closest('[data-works-filter]');
    if (!filterBtn || !root.contains(filterBtn)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    const filter = filterBtn.getAttribute('data-works-filter');
    if (!filter) {
      return;
    }

    const currentFilter = getInitialFilter(root);
    if (filter === currentFilter) {
      return;
    }

    loadWorksArchiveContent(buildFilterUrl(root, filter), root, { scrollToSection: true });
    },
    true
  );
}

if (!window.__worksArchivePopstateBound) {
  window.__worksArchivePopstateBound = true;
  window.addEventListener('popstate', () => {
    const root = getWorksArchiveRoot();
    if (!root || !document.querySelector('.p-works')) {
      return;
    }
    loadWorksArchiveContent(window.location.href, root, { updateHistory: false });
  });
}

initWorksArchive();
document.addEventListener('swup:replaced', initWorksArchive);
